import api from './api';

export interface DigitalAssistantAddonStatus {
  enabled: boolean;
  featureKey: string;
  addonName: string;
  monthlyFee: number;
  annualFee: number;
  trialDays?: number;
}

export async function getDigitalAssistantAddonStatus(
  agencySlug: string
): Promise<DigitalAssistantAddonStatus> {
  const res = await api.get(`/billing/${agencySlug}/addons/digital-assistant/status`);
  return res.data;
}
